/*
 * @Description:
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  表单设计: '表单设计',
  表单配置: '表单配置',
  表单发布: '表单发布',
  '对象名称：': '对象名称：',
  基础字段: '基础字段',
  高级字段: '高级字段',
  回收站: '回收站',
  整行: '整行',
  单列: '单列',
  两列: '两列',
  三列: '三列',
  '1/2行': '1/2行',
  '1/3行': '1/3行',
  '2/3行': '2/3行',
  字段清单: '字段清单',
  字段属性: '字段属性',
  字段设置: '字段设置',
  表单属性: '表单属性',
  表单设置: '表单设置',
  请点击选中字段进行字段属性设置: '请点击选中字段进行字段属性设置',
  '子表单数量超出限额！': '子表单数量超出限额！',
  表单设计未保存: '表单设计未保存',
  不保存: '不保存',
  '是否需要保存本次表单设计内容，并继续跳转页面？': '是否需要保存本次表单设计内容，并继续跳转页面？',
  留在当前页面: '留在当前页面',
  保存并关闭: '保存并关闭',
  '当前字段设置内容未确定，是否要继续跳转页面？': '当前字段设置内容未确定 是否要继续跳转页面？',
  配置异常字段确认: '配置异常字段确认',
  '表单设计页存在配置异常字段，请确认是否要继续跳转，跳转后新增的配置异常字段将会移入回收站、新创建的组件将会被彻底删除。': '表单设计页存在配置异常字段，请确认是否要继续跳转，跳转后新增的配置异常字段将会移入回收站、新创建的组件将会被彻底删除。',
  继续跳转: '继续跳转',
  '存在字段配置异常，请检查！': '存在字段配置异常，请检查！',
  '请输入对象名称！': '请输入对象名称！',
  请在子表单中至少添加一个自定义字段: '请在子表单中至少添加一个自定义字段',
  '格式不正确,请以http:// 或 https:// 开头,且不能包含汉字': '格式不正确,请以http:// 或 https:// 开头,且不能包含汉字',
  '此项配置有误，请检查字段属性': '此项配置有误，请检查字段属性',
  '该字段删除后将放入回收站，请确认是否要删除？': '该字段删除后将放入回收站，请确认是否要删除？',
  '该字段删除后无法被恢复，请确认是否要删除？': '该字段删除后无法被恢复，请确认是否要删除？',
  从左侧拖拽添加字段: '从左侧拖拽添加字段',
  '子表单中至少保留一个自定义字段！': '子表单中至少保留一个自定义字段！',
  异常: '异常',
  '请配置关联对象、关联主键': '请配置关联对象、关联主键',
  批量操作: '批量操作',
  允许查找关联新增数据: '允许查找关联新增数据',
  '在添加订单明细时，可以设置为从关联产品字段添加明细。设置后，您可以直接一次选择多个产品，并为每个产品都添加一行订单明细': '在添加订单明细时，可以设置为从关联产品字段添加明细。设置后，您可以直接一次选择多个产品，并为每个产品都添加一行订单明细',
  是否允许重复规则: '是否允许重复规则',
  '此项内容已存在，不允许重复创建': '此项内容已存在，不允许重复创建',
  '该查找关联(单选)字段为允许查找关联批量新增数据已配置字段，不可删除': '该查找关联(单选)字段为允许查找关联批量新增数据已配置字段，不可删除',
  '允许查找关联批量新增数据中配置的字段，会默认在表格字段设置中勾选': '允许查找关联批量新增数据中配置的字段，会默认在表格字段设置中勾选'
};
